import cn from "classnames";
import { dateToView } from "helpers/date";
import React, { useEffect, useState } from "react";
import { getCollectingTaskLogs } from "sources/admin/registryPoints";

const LastNeuralNetworkTask = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        getCollectingTaskLogs().then((data) => {
            setData(data);
            setLoading(false);
        });
    }, []);

    return (
        <div className={cn({ loading })}>
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Месяц</th>
                        <th>Кол-во точек</th>
                        <th>ID задачи</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item) => (
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{dateToView(item.month, "MMMM")}</td>
                            <td>{item.pointsCount}</td>
                            <td>{item.taskId}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LastNeuralNetworkTask;
